<template>
  <div class="d-flex align-items-center gap-2">
    <i
      v-for="icon in icons"
      :key="icon.class"
      v-b-tooltip.hover.left
      :class="[icon.class, icon.active ? 'text-success' : 'text-muted']"
      style="font-size: 1rem"
      :title="icon.title"
    />
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    option: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icons() {
      return [
        {
          class: 'icon-outline_license-general',
          active: this.rfidNumber,
          title: !!this.rfidNumber
            ? `${this.$t('global.object.rfidNumber')}: ${this.rfidNumber}`
            : `${this.$t('rfidAndFacerecognition.doesNotHaveRfid')}`,
        },
        {
          class: 'icon-outline_fr-default',
          active: this.hasValidFaceRecognition,
          title: this.hasValidFaceRecognition
            ? this.$t('rfidAndFacerecognition.faceRecognitionRegistered')
            : this.$t('rfidAndFacerecognition.notValidFaceRecognition'),
        },
      ]
    },
    identification() {
      return this.option.identification
    },
    rfidNumber() {
      return this.identification?.methods?.rfid || null
    },
    hasValidFaceRecognition() {
      return !!this.option?.photograph
    },
  },
}
</script>
